export default {
  namespaced: true,
  state: {
    connections: {}
  },
  mutations: {
    setConnection(state, connectionData) {
      state.connections[connectionData.id] = connectionData.connection
    }
  },
  actions: {
    setConnection({commit}, connectionData) {
      commit("setConnection", connectionData);
    }
  }
}
